import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { useTranslation } from 'react-i18next';
import { PLAYER_RADAR_FILTER_SOURCE, SCOPE_CONTEXT_FILTER_KEYS } from '@/analytics/snowplow/filterTracking';
import { useTrackFilterChanges } from '@/analytics/snowplow/hooks/useTrackFilterChanges';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { tableColumnEntitiesAtom } from '@/atoms/queries/tableColumns';
import { PageTitle } from '@/components/head/PageTitle';
import { PlayerLayoutWithFilters } from '@/components/layout/player/PlayerLayoutWithFilters';
import { PlayerRadar } from '@/components/player/radar/PlayerRadar';
import { useEntityPageTitle } from '@/hooks/useEntityPageTitle';
import { useTableColumns } from '@/hooks/useTableColumns';

const SetPlayerMetrics = () => {
  useTableColumns(['player_metric']);
  return null;
};

export const PlayerRadarPage = () => {
  const { t } = useTranslation('navigation');
  const playerName = useAtomValue(unwrappedSelectedPlayerNameAtom);
  const pageTitle = useEntityPageTitle(t('secondary.radar'), playerName);
  useTrackFilterChanges(SCOPE_CONTEXT_FILTER_KEYS, PLAYER_RADAR_FILTER_SOURCE);

  return (
    <ScopeProvider atoms={[tableColumnEntitiesAtom]}>
      <PageTitle>{pageTitle}</PageTitle>
      <PlayerLayoutWithFilters>
        <PlayerRadar />
      </PlayerLayoutWithFilters>
      <SetPlayerMetrics />
    </ScopeProvider>
  );
};
